import rfdc from "rfdc";

const clone = rfdc({ circles: true });

export function deepClone<T>(value: T): T {
	return clone(value);
}
